export default {
  "xxsmall-up": "(width >= 23.4375em)",
  "xxsmall-down": "(width < 23.4375em)",
  "xsmall-up": "(width >= 30em)",
  "xsmall-down": "(width < 30em)",
  "small-up": "(width >= 40em)",
  "small-down": "(width < 40em)",
  "medium-up": "(width >= 48em)",
  "medium-down": "(width < 48em)",
  "large-up": "(width >= 60em)",
  "large-down": "(width < 60em)",
  "xlarge-up": "(width >= 67.5em)",
  "xlarge-down": "(width < 67.5em)",
  "xxlarge-up": "(width >= 75em)",
  "xxlarge-down": "(width < 75em)",
  "xxxlarge-up": "(width >= 87.5em)",
  "xxxlarge-down": "(width < 87.5em)",
  "xxxxlarge-up": "(width >= 105em)",
  "xxxxlarge-down": "(width < 105em)",
  "mobile-up": "(width >= 48em)",
  "mobile-down": "(width < 48em)",
  "mobile-header-up": "(width >= 60em)",
  "mobile-header-down": "(width < 60em)",
  "search-page-overview-up": "(width >= 60em)",
  "search-page-overview-down": "(width < 60em)"
}
